export const sentryConfig = {
    url: window["env"]["sentryUrl"] || ""
}
